import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectFirstLocation, selectLocationOrGroup, selectAllGroups } from "./HandleActiveLocationGroup";

const CheckAccess = (props) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const url = useLocation();
    const user = useSelector(state => state.getUserInfo.user)
    const locationSelected = useSelector(state => state.locationSelected.location)
    const groupSelected = useSelector(state => state.groupSelected.group)
    const locations = user?.user?.locations
    const groups = user?.user?.groups
    const isAdmin = url?.pathname.includes("/app/admin")

    if(!props.hasRedirected?.current && isAdmin){
        if (locations?.length == 0) {
            navigate("/create/location")
            return;
        }

        if(locations?.every(lc => lc.is_locked) && (!locationSelected || locationSelected === "all") && !groupSelected){
            selectFirstLocation(dispatch, locations[0].id)
            navigate("/locked")
            return;
        }

        if (!locationSelected) {
            if (groupSelected) {
                let selectedGroup = groups?.find(gr => gr.id === groupSelected);
                if (selectedGroup?.locations.every(lc => lc.is_locked)) {
                    selectFirstLocation(dispatch, selectedGroup.locations[0]?.id);
                    navigate("/locked");
                    return;
                }
            } else {
                let unlockedLocation = locations?.find(lc => !lc.is_locked);
                if (unlockedLocation) {
                    selectLocationOrGroup(dispatch, unlockedLocation.id);
                } else {
                    selectAllGroups(dispatch);
                }
            }
        }
        if (locations?.filter(loc => !loc.is_locked)?.length == 1 && (!locationSelected || locationSelected === "all")) {
            let activeLocation = locations.find(lc => !lc.is_locked);
            if (activeLocation) {
                selectFirstLocation(dispatch, activeLocation.id);
            }
        }

        if (locations?.length === 1 && (!locationSelected || locationSelected === "all")) {
            let activeLocation = locations.find(lc => !lc.is_locked);
            if (activeLocation) {
                selectFirstLocation(dispatch, activeLocation.id);
            }
        }
        
    }

    return <>{props.children}</>
};

export default CheckAccess;